import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bread-section" }

import { computed, ref, watch } from "vue"
	import { useRouter, useRoute } from 'vue-router'
	
	
export default /*@__PURE__*/_defineComponent({
  __name: 'Bread',
  setup(__props) {

	const router = useRouter()
	const route = useRoute()
	
	const show = ref(false)
	const timer:Timeout = ref(null)
	const addAnimationClass = computed(() => {
		return (index:number) => {
			if(index + 1 === route.matched.length && show.value){
				return 'new'
			}
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, {
      separator: "/",
      class: "el-bread"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$route.matched, ({meta: { title }}, index) => {
          return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(addAnimationClass.value(index))
              }, _toDisplayString(title), 3)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})